import React, { useEffect, useState } from 'react';
import NoteDisplay from './NoteDisplay';
import NoteForm from './NoteForm';

import { connect } from 'react-redux';
import { fetchNotes } from '../../../../../actions/reduxActions/canvasNotes';

import '../../../../../../css/graph/note-element.less';

/**
 * 
 * @param {Array} canvasNotes Notes stored in Redux
 * @param {Object} canvasNode The DOMRect object representing the canvas DOM node
 * @param {String} flowId
 * @param {String} editingToken
 * @param {Function} fetch Retrieves all notes via API
 * @param {Object} currentUser
 * 
 * @description Displays notes as an overlay on the Flow canvas. Note
 * position is relative to their corresponding draggable note map element.
 */
const Notes = ({ canvasNotes, canvasNode, flowId, editingToken, fetch, currentUser }) => {

    const { x: canvasX, y: canvasY } = canvasNode;

    const [notes, updateNotes] = useState([]);

    useEffect(() => {
        fetch(
            flowId,
            editingToken,
            currentUser.tenantId,
            currentUser.authenticationToken,
        );
    }, []);

    useEffect(() => {
        
        // This is for calculating where the note should be positioned on
        // the canvas in relation to the note element as the canvas is zooming and panning
        const notePositions = canvasNotes.filter(cn => cn.flowId === flowId && cn.isOpen).map((note) => {
            const noteDomNode = document.getElementById(`element-inner-${note.meta.id}`);
            if (noteDomNode) {
                const { x, y, width } = noteDomNode.getBoundingClientRect();
                return { ...note, top: Math.round(y - canvasY), left: Math.round(x - canvasX), width };
            }
            return note;
        });

        updateNotes(notePositions);
    }, [canvasNotes, canvasNode]);


    return (
        <>
            {notes.map((note) => {
                const { left, top, width } = note;
                const { id, developerName, userContent, whoCreated, userContentDateModified } = note.meta;
                return (
                    <div data-testid={note.id} key={note.id}>
                        <div className="note-wrapper" style={{ left: left + width + 10, top: top - 35 }}>
                            {!note.readOnly ? (
                                <NoteForm
                                    note={note.meta}
                                    flowId={flowId}
                                    editingToken={editingToken}
                                />
                            ) : (
                                <NoteDisplay
                                    id={id}
                                    flowId={flowId}
                                    editingToken={editingToken}
                                    subject={developerName}
                                    content={userContent}
                                    email={whoCreated ? whoCreated.email : ''}
                                    lastUpdated={userContentDateModified}
                                />
                            )}
                        </div>
                    </div>
                );
            })}
        </>
    );
};

export default connect(({ currentUser, canvasNotes }) => ({ currentUser, canvasNotes }), { fetch: fetchNotes })(Notes);
